export default __webpack_public_path__ + "static/media/AnimationBlog.f26970fb.gif";